export default {
  eventsListsData: {
    es: [
      {
        capacity: 'agile',
        imageMedium: '',
        imageLarge: '/assets/images/events/headers/agile-trend-large.svg',
        title: 'festival agile trends 2021',
        subtitle: '',
        startDate: '2021-01-25T18:30:00.000Z',
        lengthEvent: '4',
        location: 'online',
        country: 'spain',
        speaker: 'Colaboradores Comité de Organización',
        type: 'Conferencia tecnológica Online',
        description: 'Agile Trends: el festival de tendencias Agile organizado por Santander',
        importantEvent: true,
        comingEvent: false,
        urlLink: 'https://agiletrends.online/',
        ariaLabel: '',
        textLink: 'Más info',
        position: '1',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '/assets/images/events/headers/agile-day-CMatias.svg',
        imageLarge: '/assets/images/events/headers/agile-day-large.svg',
        title: 'Principales roles de la agilidad',
        subtitle: 'Agile Day',
        startDate: '2020-11-26T18:30:00.000Z',
        lengthEvent: 1,
        location: 'online',
        country: 'spain',
        speaker: 'Carlos Matías',
        type: 'Conferencia tecnológica Online',
        description: 'Nuestro Head de Agile, Carlos Matías dio su charla Principales roles de la agilidad, evolución y apoyo en el Agile Day de IEBS.',
        importantEvent: true,
        comingEvent: true,
        urlLink: 'https://www.youtube.com/watch?v=5oaD-DjtPXk&feature=youtu.be&t=4089&smclient=a318756e-6928-4f0a-8a0b-cf34cf748e72&utm_source=salesmanago&utm_medium=email&utm_campaign=EVADON20',
        ariaLabel: '',
        textLink: 'Ver video',
        position: '2',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '/assets/images/events/headers/tech-fest-IMorgado.svg',
        imageLarge: '/assets/images/events/headers/tech-fest-large.svg',
        title: 'Hire to future',
        subtitle: 'T3chFest',
        startDate: '2020-11-17T18:30:00.000Z',
        lengthEvent: 1,
        location: 'online',
        country: 'spain',
        speaker: 'Irene Morgado',
        type: ' Conferencia tecnológica Online',
        description: 'Nuestra Head de Talento y Marca, Irene Morgado, participó en el T3chFest con su charla Hire to Future, donde habló de hiring, cultura y salud mental en el presente y futuro próximo.',
        importantEvent: true,
        comingEvent: true,
        urlLink: 'https://www.youtube.com/watch?v=SlTCBIZGNkI',
        ariaLabel: '',
        textLink: 'Ver video',
        position: '3',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '',
        imageLarge: '/assets/images/events/headers/forum-leaders-latam-large.svg',
        title: 'Foro de Líderes de la Transformación Latam',
        subtitle: '',
        startDate: '2020-10-31T18:30:00.000Z',
        lengthEvent: 1,
        speaker: 'Varios ponentes',
        type: 'Charlas Empresariales Online',
        location: 'online',
        country: 'latam',
        description: 'La reunión más grande entre las industrias de transformación empresarial. Kairós DS tuvo intervenciones de Carlos Moure, Adrián Solca, Luis Gómez, Toni Navarro, Dinorah Hurtado y José Alberto Rodríguez.',
        importantEvent: true,
        comingEvent: false,
        urlLink: 'https://www.youtube.com/watch?v=U9ffSdIiM6o',
        ariaLabel: '',
        textLink: 'Ver video',
        position: '4',
        relatedEventID: '',
      },
      {
        capacity: 'dev',
        imageMedium: '/assets/images/events/headers/web-componets-MFosela.svg',
        imageLarge: '',
        title: 'Entre componentes anda el juego',
        subtitle: '',
        startDate: '2021-01-14T18:30:00.000Z',
        lengthEvent: 1,
        location: 'online',
        country: 'spain',
        speaker: 'Mánu Fosela',
        type: 'Charla',
        description: 'Nuestro Head de Desarrollo, Manu Fosela, estuvo en el canal de Twitch de Jorge del Casar hablando de Web Components y respondiendo a dudas de los presentes.',
        importantEvent: false,
        comingEvent: true,
        urlLink: 'https://www.youtube.com/watch?v=P-t9MJ1dGLE',
        ariaLabel: '',
        textLink: 'Ver video',
        position: '1',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '/assets/images/events/headers/agile-trends-TNavarro.svg',
        imageLarge: '',
        title: 'De la Estrategia empresarial a la Operativa de los equipos: Portfolio y OKRs directores de orquesta',
        subtitle: '',
        startDate: '2021-01-26T18:30:00.000Z',
        lengthEvent: 1,
        location: 'online',
        country: 'spain',
        speaker: 'Toni Navarro',
        type: 'Workshop',
        description: 'Nuestro Head de Agile, Toni Navarro, participó en el Festival Agile Trends con su workshop, donde agilistas experimentados y profesionales de entornos ágiles reflexionaron sobre cómo la agilidad podrá ayudarnos en el nuevo año.',
        importantEvent: false,
        comingEvent: true,
        urlLink: 'https://agiletrends.online/',
        ariaLabel: '',
        textLink: '',
        position: '2',
        relatedEventID: '',
      },
      {
        capacity: 'devops',
        imageMedium: '/assets/images/events/headers/agile-trends-LGomez.svg',
        imageLarge: '',
        title: 'Assessment DevOps. Herramientas para averiguar cómo alcanzar el CI/CD',
        subtitle: '',
        startDate: '2021-01-27T18:30:00.000Z',
        lengthEvent: 1,
        location: 'online',
        country: 'spain',
        speaker: 'Luis Gómez',
        type: 'Charla',
        description: 'Nuestro Head de DevOps, Luis J. Gómez Vázquez, participó en el Festival Agile Trends con su charla, donde agilistas experimentados y profesionales de entornos ágiles reflexionaron sobre cómo la agilidad podrá ayudarnos en el nuevo año.',
        importantEvent: false,
        comingEvent: true,
        urlLink: 'https://agiletrends.online/',
        ariaLabel: '',
        textLink: '',
        position: '3',
        relatedEventID: '',
      },
      {
        capacity: 'design',
        imageMedium: '',
        imageLarge: '',
        title: 'Company Week Uxer School',
        subtitle: '',
        startDate: '2020-12-02T18:30:00.000Z',
        lengthEvent: 1,
        location: 'online',
        country: 'spain',
        speaker: 'Juan Antonio Sanz',
        type: 'Participación',
        description: 'Nuestro Head de UX, Juan Antonio Sanz Moreno participó en la COMPANY Week organizada por UXER SCHOOL, donde dan a conocer a sus alumnos a empresas referentes en el sector tecnológico y digital.',
        importantEvent: false,
        comingEvent: true,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'dev',
        imageMedium: '/assets/images/events/headers/codemotion-2020.svg',
        imageLarge: '',
        title: 'Codemotion',
        subtitle: '',
        startDate: '2020-11-04T18:30:00.000Z',
        lengthEvent: '',
        location: 'online',
        country: 'spain',
        speaker: 'Irene Morgado + Manu Fosela',
        type: 'charla',
        description: 'Nuestro compañero Mánu Fosela fue Maestro de Ceremonias en uno de los tracks de frontend en Codemotion y nuestra Head de Talento y Marca, Irene Morgado participó con su charla Bias Story, hablando de cómo los sesgos influyen en el día a día profesional y cómo tratarlos para sacar beneficio de ellos.',
        importantEvent: false,
        comingEvent: true,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '/assets/images/events/headers/agile-covid-PAM20.svg',
        imageLarge: '',
        title: 'PAM',
        subtitle: 'Charla y patrocinio',
        startDate: '2020-11-16T18:30:00.000Z',
        lengthEvent: 1,
        location: 'online',
        country: 'spain',
        speaker: 'Juan José Vallina',
        type: 'Charla',
        description: 'Somos orgullosos patrocinadores y nuestro compañero Juan José Vallina Castro participó en ella, donde se pudo conversar con él en directo.',
        importantEvent: false,
        comingEvent: true,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '',
        imageLarge: '',
        title: 'AgilityTRes60 patrocinio y charla',
        subtitle: '',
        startDate: '2020-10-03T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Toni Navarro',
        type: 'Charla',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: 'https://www.youtube.com/watch?v=Kp6HfbBl5qM&feature=youtu.be ',
        ariaLabel: '',
        textLink: 'Ver video',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '',
        imageLarge: '',
        title: 'cuando tu empresa contraataca',
        subtitle: 'DevFest 2020',
        startDate: '2020-10-16T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Irene Morgado',
        type: 'Charla',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: 'https://www.youtube.com/watch?v=l3MxmMZO_44',
        ariaLabel: '',
        textLink: 'Ver video',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '',
        imageLarge: '',
        title: 'Agile in the new normal CAS- patrocinio',
        subtitle: '',
        startDate: '2020-10-29T18:30:00.000Z',
        lengthEvent: 2,
        location: '',
        country: '',
        speaker: 'Kairós DS',
        type: 'Patrocinio',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '',
        imageLarge: '',
        title: 'La pandemia demanda agilidad: cómo puede la metodología Agile salvar a las empresas',
        subtitle: '',
        startDate: '2020-09-07T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: 'spain',
        speaker: 'Carlos Moure',
        type: 'Publicación',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '',
        imageLarge: '',
        title: 'Festival Agile Trends - Colaboración y charlas',
        subtitle: '',
        startDate: '2020-09-09T18:30:00.000Z',
        lengthEvent: 2,
        location: '',
        country: '',
        speaker: 'Varios Kairós DS',
        type: 'Charla',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: 'https://agiletrends.online/',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'dev',
        imageMedium: '',
        imageLarge: '',
        title: 'Feria Talento Codenotch',
        subtitle: '',
        startDate: '2020-09-22T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Varios Kairós DS',
        type: 'Participación',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '',
        imageLarge: '',
        title: 'Premio a la Innovación Tecnológica',
        subtitle: 'El Suplemento',
        startDate: '2020-09-26T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Varios Kairós DS',
        type: 'Premio',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '',
        imageLarge: '',
        title: 'Panel Retos culturales de la transformación Latam',
        subtitle: '',
        startDate: '2020-09-26T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Kairós Academy Latam',
        type: 'Webinar',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '',
        imageLarge: '',
        title: 'Participación feria talento UNIR',
        subtitle: '',
        startDate: '2020-09-28T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Varios Kairós DS',
        type: 'Recruiting',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '',
        imageLarge: '',
        title: 'conversaciones entre diseñadoras y recruiters',
        subtitle: 'Ladies that UX',
        startDate: '2020-09-29T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Irene Morgado',
        type: 'Charla',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: 'https://anchor.fm/ladiesthatux-ma/episodes/Ep-15--Conversaciones-entre-diseadoras-y-recruiters-ep7fg8/a-a4foflh',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '',
        imageLarge: '',
        title: 'Revista APD',
        subtitle: 'Re-skilling',
        startDate: '2020-09-29T18:30:00.000Z',
        lengthEvent: '',
        location: '',
        country: '',
        speaker: 'Carlos Moure',
        type: 'Publicación',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '',
        imageLarge: '',
        title: 'Patrocinio Estudio geofísico yacimiento Peña del Moro',
        subtitle: '',
        startDate: '2020-08-29T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Carlos Moure',
        type: 'Publicación',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '',
        imageLarge: '',
        title: 'La transformación Agile, clave del éxito para tu organización',
        subtitle: '',
        startDate: '2020-07-03T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Varios Kairós DS',
        type: 'Webinar',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: 'https://www.youtube.com/watch?v=u9DMVB6uvXE&feature=youtu.be',
        ariaLabel: '',
        textLink: 'Ver video',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'corporate',
        imageMedium: '',
        imageLarge: '',
        title: '¿Qué hace alguien como tú en un sitio como este?',
        subtitle: '',
        startDate: '2020-07-07T18:30:00.000Z',
        lengthEvent: 1,
        location: '',
        country: '',
        speaker: 'Irene Morgado',
        type: 'Webinar',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: 'https://www.youtube.com/watch?time_continue=1&v=fvceDnKWEJE&feature=emb_logo',
        ariaLabel: '',
        textLink: 'Ver video',
        position: '',
        relatedEventID: '',
      },
      {
        capacity: 'agile',
        imageMedium: '',
        imageLarge: '',
        title: 'Patrocinadores AOOS 2020 y charla: Planificación con incertidumbre',
        subtitle: '',
        startDate: '2020-07-24T18:30:00.000Z',
        lengthEvent: 2,
        location: '',
        country: '',
        speaker: 'Toni Navarro',
        type: 'Charla',
        description: '',
        importantEvent: false,
        comingEvent: false,
        urlLink: '',
        ariaLabel: '',
        textLink: '',
        position: '',
        relatedEventID: '',
      },
    ],
    en: [],
  },
};
